<ng-container *ngIf="_question.question && createUser">

  <div style="display: flex; align-items: center;" [attr.data-questionTitleId]="_question.key">
    <button (click)="openChat()" mat-flat-button *ngIf="displayChat && (chatService.comments$ | async) as comments">
      <mat-icon [matBadge]="getCommentCountByQuestion(comments)"
                class="icon-size-6"
                [svgIcon]="'mat_outline:comment'"
                aria-hidden="false"></mat-icon>
    </button>
    <div *ngIf="_question.viewerType !== questionType.HEADER" class="ml-2">
      <mat-icon color="warn"
                *ngIf="surveyViewerService.activeSurvey$.value.form.get(_question.key).invalid && surveyViewerService.allFormControlsMarkedAsTouched$.value"
                [matTooltip]="'Cette question est incomplète.'|transloco">
        error
      </mat-icon>
      <mat-icon [color]="(validateAIService.questionAIValidationStatus$ | async)?.[_question.key] === false ? '' : 'primary'"
                [style.color]="(validateAIService.questionAIValidationStatus$ | async)?.[_question.key] === false ? '#FFA500' : ''"
                *ngIf="surveyViewerService.activeSurvey$.value.form.get(_question.key).valid &&
                 (surveyViewerService.allFormControlsMarkedAsTouched$.value || surveyViewerService.activeSurvey$.value.form.get(_question.key).touched)">
        done
      </mat-icon>
    </div>

    <div
      class="fr-view md:w-auto m-2 question-label"
      [innerHTML]="_question.question | translateLabel: activeLang | safeHtml"></div>
  </div>

</ng-container>

<div class="m-2" id="{{_question.key}}">
  <ng-container appQuestion></ng-container>
</div>
